import { render, staticRenderFns } from "./formPage.vue?vue&type=template&id=4ab5d64b"
import script from "./formPage.vue?vue&type=script&lang=js"
export * from "./formPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports